import React from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

interface PaginationButtonGroupProps {
  currentPage: number;
  totalPages: number;
  onPageChange?: (page: number) => void;
}

export const PaginationButtonGroup: React.FC<PaginationButtonGroupProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => (
  <div className="flex items-center space-x-2">
    <button
      onClick={() => onPageChange && onPageChange(1)}
      disabled={currentPage === 1}
      className={
        currentPage === 1
          ? "text-gray-300 cursor-not-allowed"
          : "text-gray-500 hover:text-gray-700 cursor-pointer"
      }
    >
      <ChevronsLeft className="h-4 w-4" />
    </button>
    <button
      onClick={() => onPageChange && onPageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className={
        currentPage === 1
          ? "text-gray-300 cursor-not-allowed"
          : "text-gray-500 hover:text-gray-700 cursor-pointer"
      }
    >
      <ChevronLeft className="h-4 w-4" />
    </button>
    <span
      aria-current="page"
      className="px-3 py-1.5 BookEZ_font_body_size BookEZ_font_body_medium BookEZ_font_color_gray_2 BookEZ_pagination_active_page_bg rounded-md"
    >
      {currentPage}
    </span>
    <button
      onClick={() => onPageChange && onPageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
      className={
        currentPage === totalPages
          ? "text-gray-300 cursor-not-allowed"
          : "text-gray-500 hover:text-gray-700 cursor-pointer"
      }
    >
      <ChevronRight className="h-4 w-4" />
    </button>
    <button
      onClick={() => onPageChange && onPageChange(totalPages)}
      disabled={currentPage === totalPages}
      className={
        currentPage === totalPages
          ? "text-gray-300 cursor-not-allowed"
          : "text-gray-500 hover:text-gray-700 cursor-pointer"
      }
    >
      <ChevronsRight className="h-4 w-4" />
    </button>
  </div>
);
